// City names by language
const cityNames = {
  tallinn: { ru: 'Таллинн', en: 'Tallinn', lv: 'Tallina', lt: 'Talinas', pl: 'Tallinn' },
  tartu: { ru: 'Тарту', en: 'Tartu', lv: 'Tartu', lt: 'Tartu', pl: 'Tartu' },
  narva: { ru: 'Нарва', en: 'Narva', lv: 'Narva', lt: 'Narva', pl: 'Narwa' },
  parnu: { ru: 'Пярну', en: 'Pärnu', lv: 'Pērnava', lt: 'Pernu', pl: 'Parnawa' },
  viljandi: { ru: 'Вильянди', en: 'Viljandi', lv: 'Viljandi', lt: 'Viljandis', pl: 'Viljandi' },
  rakvere: { ru: 'Раквере', en: 'Rakvere', lv: 'Rakvere', lt: 'Rakvere', pl: 'Rakvere' },
  kuressaare: { ru: 'Курессааре', en: 'Kuressaare', lv: 'Kuressāre', lt: 'Kuressarė', pl: 'Kuressaare' },
  haapsalu: { ru: 'Хаапсалу', en: 'Haapsalu', lv: 'Hāpsala', lt: 'Haapsalu', pl: 'Haapsalu' },
  hiiumaa: { ru: 'Хийумаа', en: 'Hiiumaa', lv: 'Hījumā', lt: 'Hiumaa', pl: 'Hiuma' },
  riga: { ru: 'Рига', en: 'Riga', lv: 'Rīga', lt: 'Ryga', pl: 'Ryga' },
  daugavpils: { ru: 'Даугавпилс', en: 'Daugavpils', lv: 'Daugavpils', lt: 'Daugpilis', pl: 'Dyneburg' },
  liepaja: { ru: 'Лиепая', en: 'Liepāja', lv: 'Liepāja', lt: 'Liepoja', pl: 'Lipawa' },
  vilnius: { ru: 'Вильнюс', en: 'Vilnius', lv: 'Viļņa', lt: 'Vilnius', pl: 'Wilno' },
  kaunas: { ru: 'Каунас', en: 'Kaunas', lv: 'Kauņa', lt: 'Kaunas', pl: 'Kowno' },
  panevezys: { ru: 'Паневежис', en: 'Panevėžys', lv: 'Paņevēža', lt: 'Panevėžys', pl: 'Poniewież' },
  klaipeda: { ru: 'Клайпеда', en: 'Klaipėda', lv: 'Klaipēda', lt: 'Klaipėda', pl: 'Kłajpeda' },
  palanga: { ru: 'Паланга', en: 'Palanga', lv: 'Palanga', lt: 'Palanga', pl: 'Połąga' },
  warsaw: { ru: 'Варшава', en: 'Warsaw', lv: 'Varšava', lt: 'Varšuva', pl: 'Warszawa' },
  suwalki: { ru: 'Сувалки', en: 'Suwałki', lv: 'Suvalki', lt: 'Suvalkai', pl: 'Suwałki' },
  helsinki: { ru: 'Хельсинки', en: 'Helsinki', lv: 'Helsinki', lt: 'Helsinkis', pl: 'Helsinki' },
  spb: { ru: 'Санкт-Петербург', en: 'St. Petersburg', lv: 'Sanktpēterburga', lt: 'Sankt Peterburgas', pl: 'Sankt Petersburg' },
};

const countryNames = {
  estonia: { ru: 'Эстония', en: 'Estonia', lv: 'Igaunija', lt: 'Estija', pl: 'Estonia' },
  latvia: { ru: 'Латвия', en: 'Latvia', lv: 'Latvija', lt: 'Latvija', pl: 'Łotwa' },
  lithuania: { ru: 'Литва', en: 'Lithuania', lv: 'Lietuva', lt: 'Lietuva', pl: 'Litwa' },
  poland: { ru: 'Польша', en: 'Poland', lv: 'Polija', lt: 'Lenkija', pl: 'Polska' },
  finland: { ru: 'Финляндия', en: 'Finland', lv: 'Somija', lt: 'Suomija', pl: 'Finlandia' },
  russia: { ru: 'Россия', en: 'Russia', lv: 'Krievija', lt: 'Rusija', pl: 'Rosja' },
};

const busStationLabel = {
  ru: 'Автовокзал', en: 'Bus station', lv: 'Autoosta', lt: 'Autobusų stotis', pl: 'Dworzec autobusowy',
};

export const getCityName = (cityId, lang) => cityNames[cityId]?.[lang] || cityNames[cityId]?.en || cityId;
export const getCountryName = (countryId, lang) => countryNames[countryId]?.[lang] || countryNames[countryId]?.en || countryId;
export const getBusStation = (lang) => busStationLabel[lang] || busStationLabel.en;

export const getCities = (lang) => {
  const bs = getBusStation(lang);
  return [
    // Estonia
    { id: 'tallinn', name: `${getCityName('tallinn', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    { id: 'tartu', name: `${getCityName('tartu', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    { id: 'narva', name: `${getCityName('narva', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    { id: 'parnu', name: `${getCityName('parnu', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    { id: 'viljandi', name: `${getCityName('viljandi', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    { id: 'rakvere', name: `${getCityName('rakvere', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    { id: 'kuressaare', name: `${getCityName('kuressaare', lang)}, ${bs}`, country: getCountryName('estonia', lang) },
    // Latvia
    { id: 'riga', name: `${getCityName('riga', lang)}, ${bs}`, country: getCountryName('latvia', lang) },
    { id: 'daugavpils', name: `${getCityName('daugavpils', lang)}, ${bs}`, country: getCountryName('latvia', lang) },
    { id: 'liepaja', name: `${getCityName('liepaja', lang)}, ${bs}`, country: getCountryName('latvia', lang) },
    // Lithuania
    { id: 'vilnius', name: `${getCityName('vilnius', lang)}, ${bs}`, country: getCountryName('lithuania', lang) },
    { id: 'kaunas', name: `${getCityName('kaunas', lang)}, ${bs}`, country: getCountryName('lithuania', lang) },
    { id: 'panevezys', name: `${getCityName('panevezys', lang)}, ${bs}`, country: getCountryName('lithuania', lang) },
    { id: 'klaipeda', name: `${getCityName('klaipeda', lang)}, ${bs}`, country: getCountryName('lithuania', lang) },
    { id: 'palanga', name: getCityName('palanga', lang), country: getCountryName('lithuania', lang) },
    // Poland
    { id: 'warsaw', name: `${getCityName('warsaw', lang)}, Zachodnia`, country: getCountryName('poland', lang) },
    { id: 'suwalki', name: `${getCityName('suwalki', lang)}, ${bs}`, country: getCountryName('poland', lang) },
    // Finland & Russia
    { id: 'helsinki', name: getCityName('helsinki', lang), country: getCountryName('finland', lang) },
    { id: 'spb', name: getCityName('spb', lang), country: getCountryName('russia', lang) },
  ];
};

// Keep backward-compatible static export for components that don't use lang yet
export const cities = getCities('ru');

export const getPopularRoutes = (lang) => [
  { from: getCityName('tallinn', lang), to: getCityName('riga', lang), fromSub: getCountryName('estonia', lang), toSub: getCountryName('latvia', lang) },
  { from: getCityName('riga', lang), to: getCityName('vilnius', lang), fromSub: getCountryName('latvia', lang), toSub: getCountryName('lithuania', lang) },
  { from: getCityName('vilnius', lang), to: getCityName('warsaw', lang), fromSub: getCountryName('lithuania', lang), toSub: getCountryName('poland', lang) },
  { from: getCityName('tallinn', lang), to: getCityName('tartu', lang), fromSub: getCountryName('estonia', lang), toSub: getCountryName('estonia', lang) },
  { from: getCityName('riga', lang), to: getCityName('tallinn', lang), fromSub: getCountryName('latvia', lang), toSub: getCountryName('estonia', lang) },
  { from: getCityName('riga', lang), to: getCityName('kaunas', lang), fromSub: getCountryName('latvia', lang), toSub: getCountryName('lithuania', lang) },
  { from: getCityName('tallinn', lang), to: getCityName('narva', lang), fromSub: getCountryName('estonia', lang), toSub: getCountryName('estonia', lang) },
  { from: getCityName('vilnius', lang), to: getCityName('riga', lang), fromSub: getCountryName('lithuania', lang), toSub: getCountryName('latvia', lang) },
  { from: getCityName('riga', lang), to: getCityName('daugavpils', lang), fromSub: getCountryName('latvia', lang), toSub: getCountryName('latvia', lang) },
  { from: getCityName('riga', lang), to: getCityName('liepaja', lang), fromSub: getCountryName('latvia', lang), toSub: getCountryName('latvia', lang) },
];

export const popularRoutes = getPopularRoutes('ru');

const durationLabels = {
  h: { ru: 'ч', en: 'h', lv: 'st', lt: 'val', pl: 'godz' },
  min: { ru: 'мин', en: 'min', lv: 'min', lt: 'min', pl: 'min' },
};

export const formatDuration = (minutes, lang = 'ru') => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}${durationLabels.h[lang] || 'h'} ${m}${durationLabels.min[lang] || 'min'}`;
};

// Real route durations in minutes (based on luxexpress.eu schedules)
const routeDurations = {
  // Estonia internal (real prices from luxexpress.eu)
  'tallinn-tartu': { min: 130, max: 150, price: [9, 15], freq: 8 },
  'tartu-tallinn': { min: 130, max: 150, price: [9, 15], freq: 8 },
  'tallinn-narva': { min: 195, max: 220, price: [10, 18], freq: 5 },
  'narva-tallinn': { min: 195, max: 220, price: [10, 18], freq: 5 },
  'tallinn-parnu': { min: 120, max: 140, price: [8, 14], freq: 6 },
  'parnu-tallinn': { min: 120, max: 140, price: [8, 14], freq: 6 },
  'tartu-narva': { min: 150, max: 180, price: [8, 14], freq: 3 },
  'narva-tartu': { min: 150, max: 180, price: [8, 14], freq: 3 },
  // International: Tallinn-Riga ~4h 15m-4h 40m, from €11.50-€38
  'tallinn-riga': { min: 255, max: 280, price: [12, 38], freq: 7 },
  'riga-tallinn': { min: 255, max: 280, price: [12, 38], freq: 7 },
  // Tallinn-Vilnius ~9h-10h, from €18-€52
  'tallinn-vilnius': { min: 540, max: 600, price: [18, 52], freq: 2 },
  'vilnius-tallinn': { min: 540, max: 600, price: [18, 52], freq: 2 },
  // Riga-Vilnius ~4h-4h 30m, from €12-€32
  'riga-vilnius': { min: 240, max: 270, price: [12, 32], freq: 7 },
  'vilnius-riga': { min: 240, max: 270, price: [12, 32], freq: 7 },
  // Riga-Kaunas ~3h 30m-4h 10m, from €12-€28
  'riga-kaunas': { min: 210, max: 250, price: [12, 28], freq: 4 },
  'kaunas-riga': { min: 210, max: 250, price: [12, 28], freq: 4 },
  // Riga-Warsaw ~11h-12h, from €25-€65
  'riga-warsaw': { min: 660, max: 720, price: [25, 65], freq: 2 },
  'warsaw-riga': { min: 660, max: 720, price: [25, 65], freq: 2 },
  // Riga-Pärnu ~2h 30m-3h
  'riga-parnu': { min: 150, max: 180, price: [10, 20], freq: 3 },
  'parnu-riga': { min: 150, max: 180, price: [10, 20], freq: 3 },
  // Vilnius-Kaunas ~1h 30m-1h 50m
  'vilnius-kaunas': { min: 90, max: 110, price: [7, 14], freq: 6 },
  'kaunas-vilnius': { min: 90, max: 110, price: [7, 14], freq: 6 },
  // Vilnius-Warsaw ~7h 30m-9h
  'vilnius-warsaw': { min: 450, max: 540, price: [15, 46], freq: 3 },
  'warsaw-vilnius': { min: 450, max: 540, price: [15, 46], freq: 3 },
  // Kaunas-Warsaw ~6h 30m-7h 30m
  'kaunas-warsaw': { min: 390, max: 450, price: [14, 38], freq: 2 },
  'warsaw-kaunas': { min: 390, max: 450, price: [14, 38], freq: 2 },
  // Tallinn-Warsaw ~16h-17h
  'tallinn-warsaw': { min: 960, max: 1020, price: [26, 58], freq: 1 },
  'warsaw-tallinn': { min: 960, max: 1020, price: [26, 58], freq: 1 },
  // Estonia internal extra routes
  'tallinn-viljandi': { min: 150, max: 175, price: [8, 14], freq: 4 },
  'viljandi-tallinn': { min: 150, max: 175, price: [8, 14], freq: 4 },
  'tallinn-rakvere': { min: 80, max: 100, price: [6, 11], freq: 5 },
  'rakvere-tallinn': { min: 80, max: 100, price: [6, 11], freq: 5 },
  'tallinn-kuressaare': { min: 240, max: 270, price: [12, 20], freq: 3 },
  'kuressaare-tallinn': { min: 240, max: 270, price: [12, 20], freq: 3 },
  'tartu-viljandi': { min: 60, max: 80, price: [5, 10], freq: 3 },
  'viljandi-tartu': { min: 60, max: 80, price: [5, 10], freq: 3 },
  'tartu-parnu': { min: 135, max: 160, price: [8, 14], freq: 3 },
  'parnu-tartu': { min: 135, max: 160, price: [8, 14], freq: 3 },
  'rakvere-narva': { min: 90, max: 110, price: [6, 12], freq: 3 },
  'narva-rakvere': { min: 90, max: 110, price: [6, 12], freq: 3 },
  // Latvia internal
  'riga-daugavpils': { min: 210, max: 240, price: [10, 18], freq: 4 },
  'daugavpils-riga': { min: 210, max: 240, price: [10, 18], freq: 4 },
  'riga-liepaja': { min: 195, max: 225, price: [10, 18], freq: 4 },
  'liepaja-riga': { min: 195, max: 225, price: [10, 18], freq: 4 },
  // Lithuania: Panevėžys routes
  'panevezys-riga': { min: 150, max: 180, price: [10, 20], freq: 3 },
  'riga-panevezys': { min: 150, max: 180, price: [10, 20], freq: 3 },
  'panevezys-tallinn': { min: 420, max: 480, price: [18, 40], freq: 1 },
  'tallinn-panevezys': { min: 420, max: 480, price: [18, 40], freq: 1 },
  'panevezys-vilnius': { min: 120, max: 150, price: [8, 16], freq: 4 },
  'vilnius-panevezys': { min: 120, max: 150, price: [8, 16], freq: 4 },
  'panevezys-kaunas': { min: 90, max: 120, price: [7, 14], freq: 3 },
  'kaunas-panevezys': { min: 90, max: 120, price: [7, 14], freq: 3 },
  'panevezys-warsaw': { min: 480, max: 540, price: [16, 38], freq: 1 },
  'warsaw-panevezys': { min: 480, max: 540, price: [16, 38], freq: 1 },
  // Klaipėda / Palanga (summer seasonal)
  'liepaja-klaipeda': { min: 120, max: 150, price: [8, 16], freq: 2 },
  'klaipeda-liepaja': { min: 120, max: 150, price: [8, 16], freq: 2 },
  'liepaja-palanga': { min: 100, max: 130, price: [7, 14], freq: 2 },
  'palanga-liepaja': { min: 100, max: 130, price: [7, 14], freq: 2 },
  'riga-klaipeda': { min: 300, max: 345, price: [14, 28], freq: 2 },
  'klaipeda-riga': { min: 300, max: 345, price: [14, 28], freq: 2 },
  'riga-palanga': { min: 280, max: 320, price: [13, 26], freq: 2 },
  'palanga-riga': { min: 280, max: 320, price: [13, 26], freq: 2 },
  'vilnius-klaipeda': { min: 240, max: 280, price: [12, 24], freq: 3 },
  'klaipeda-vilnius': { min: 240, max: 280, price: [12, 24], freq: 3 },
  'kaunas-klaipeda': { min: 180, max: 210, price: [10, 20], freq: 3 },
  'klaipeda-kaunas': { min: 180, max: 210, price: [10, 20], freq: 3 },
  // Poland: Suwałki
  'suwalki-warsaw': { min: 300, max: 360, price: [12, 28], freq: 2 },
  'warsaw-suwalki': { min: 300, max: 360, price: [12, 28], freq: 2 },
  'suwalki-vilnius': { min: 180, max: 210, price: [10, 22], freq: 2 },
  'vilnius-suwalki': { min: 180, max: 210, price: [10, 22], freq: 2 },
  'suwalki-kaunas': { min: 150, max: 180, price: [9, 18], freq: 2 },
  'kaunas-suwalki': { min: 150, max: 180, price: [9, 18], freq: 2 },
  // Helsinki / SPb
  'tallinn-helsinki': { min: 150, max: 180, price: [15, 30], freq: 3 },
  'helsinki-tallinn': { min: 150, max: 180, price: [15, 30], freq: 3 },
  'tallinn-spb': { min: 360, max: 420, price: [20, 45], freq: 2 },
  'spb-tallinn': { min: 360, max: 420, price: [20, 45], freq: 2 },
  'riga-spb': { min: 660, max: 720, price: [30, 60], freq: 1 },
  'spb-riga': { min: 660, max: 720, price: [30, 60], freq: 1 },
};

const getRouteKey = (from, to) => {
  // Find city IDs from display names
  const findId = (name) => {
    for (const [id, names] of Object.entries(cityNames)) {
      if (Object.values(names).some(n => name.toLowerCase().includes(n.toLowerCase().split(',')[0]))) return id;
    }
    return null;
  };
  const fromId = findId(from);
  const toId = findId(to);
  return fromId && toId ? `${fromId}-${toId}` : null;
};

// Deterministic pseudo-random number generator (seeded)
const seedRandom = (seed) => {
  let s = seed;
  return () => {
    s = (s * 1664525 + 1013904223) & 0xffffffff;
    return (s >>> 0) / 0xffffffff;
  };
};

const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const generateTrips = (from, to, date, lang = 'ru') => {
  const trips = [];
  const routeKey = getRouteKey(from, to);
  const route = routeKey ? routeDurations[routeKey] : null;

  // Defaults if route not found
  const minDur = route ? route.min : 180;
  const maxDur = route ? route.max : 270;
  const priceRange = route ? route.price : [10, 25];
  const freq = route ? route.freq : 4;

  // Seed based on route + date (NOT language) so trips stay stable across lang switches
  const seed = hashString(`${routeKey || from + to}-${date}`);
  const rand = seedRandom(seed);

  const baseHours = [6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22];
  const count = Math.min(freq, baseHours.length);
  const shuffled = [...baseHours].map(h => ({ h, r: rand() })).sort((a, b) => a.r - b.r);
  const selectedHours = shuffled.slice(0, count).map(x => x.h).sort((a, b) => a - b);

  selectedHours.forEach((hour, idx) => {
    const minutes = Math.floor(rand() * 4) * 15;
    // Vary duration slightly around real range
    const duration = minDur + Math.floor(rand() * (maxDur - minDur));
    const totalMin = hour * 60 + minutes + duration;
    const arrHour = Math.floor(totalMin / 60) % 24;
    const arrMin = totalMin % 60;
    // Price varies within real range, earlier = cheaper
    const priceFactor = 0.7 + rand() * 0.6;
    const basePrice = priceRange[0] + (priceRange[1] - priceRange[0]) * priceFactor;
    const price = Math.round(basePrice);
    const isLounge = rand() > 0.5;

    trips.push({
      id: `trip-${routeKey || 'x'}-${date}-${idx}`,
      departureTime: `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
      arrivalTime: `${String(arrHour).padStart(2, '0')}:${String(arrMin).padStart(2, '0')}`,
      duration: formatDuration(duration, lang),
      durationMin: duration,
      from,
      to,
      date,
      price,
      priceLounge: Math.round(price * 1.4),
      type: isLounge ? 'LUX Lounge' : 'LUX Express',
      carrier: 'LUX Express',
      available: Math.floor(rand() * 30) + 5,
    });
  });

  return trips;
};


export const getDestinationImages = (lang) => [
  { id: 'tallinn', city: getCityName('tallinn', lang), url: 'https://avatars.mds.yandex.net/i?id=34300261bd915a35a2a090db68f78e1b0d8bd8f2-16509678-images-thumbs&n=13' },
  { id: 'helsinki', city: getCityName('helsinki', lang), url: 'https://images.unsplash.com/photo-1538332576228-eb5b4c4de6f5?w=600&h=450&fit=crop' },
  { id: 'narva', city: getCityName('narva', lang), url: 'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/destination-narva-gallery-08_fHxoX0AMQc_L9QaYb87oz.jpg' },
  { id: 'riga', city: getCityName('riga', lang), url: 'https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=600&h=450&fit=crop' },
  { id: 'tartu', city: getCityName('tartu', lang), url: 'https://images.unsplash.com/photo-1576941089238-6b71090d96f8?w=600&h=450&fit=crop' },
  { id: 'vilnius', city: getCityName('vilnius', lang), url: 'https://images.unsplash.com/photo-1549891472-991e6bc75d1e?w=600&h=450&fit=crop' },
  { id: 'warsaw', city: getCityName('warsaw', lang), url: 'https://images.unsplash.com/photo-1607427293702-036933bbf746?w=600&h=450&fit=crop' },
  { id: 'parnu', city: getCityName('parnu', lang), url: 'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/destination-parnu-gallery-09_AC4YIinM0X.jpg' },
  { id: 'kuressaare', city: getCityName('kuressaare', lang), url: 'https://airport.ee/wp-content/uploads/2023/11/Kuressaare-Castle_Rainer-Suvirand.jpg' },
  { id: 'daugavpils', city: getCityName('daugavpils', lang), url: 'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/destination-daugavpils-gallery-02_22kCzHhkGB_eoia7tu27t.jpg' },
  { id: 'liepaja', city: getCityName('liepaja', lang), url: 'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/Beach_hzNhWTTDuu.jpg' },
  { id: 'haapsalu', city: getCityName('haapsalu', lang), url: 'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/destination-haapsalu-gallery-01.jpg' },
  { id: 'hiiumaa', city: getCityName('hiiumaa', lang), url: 'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/lux-express-k%C3%A4rdla_VxS86NRPnY_p5riSZCzFY.jpg' },
];

export const destinationImages = getDestinationImages('ru');
